
import Navbar from './comnComponents/navbar';
function App() {
  return (
<>
<Navbar/>
<div className="flex items-center justify-center h-screen bg-gray-100">
      <h1 className="text-3xl font-bold text-blue-600">
        our website is currently under developement
      </h1>
    </div>
</>
    
  );
}

export default App;
